/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { TaskTreeItem_TreeItemFragmentDoc, TaskTreeItem_TreeListItemFragmentDoc } from '../../tasks/trees.generated.js';
import { VirtualItem__DocumentItemFragmentDoc } from '../../../trees-virtual/types.generated.js';
import { PhotoApprovalProcessFragmentDoc } from '../../tasks/PhotoApprovalProcess.generated.js';
import { AddTaskWorkSessionsProcess_ItemFragmentDoc } from '../../work-sessions/AddTaskWorkSessionsProcess.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectOverviewNextTasksBoxQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectOverviewNextTasksBoxQuery = { organisationDefaults: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationDefaults', id: string, defaultTaskPhotoIsRequired: boolean } };

export type ProjectOverviewNextTasksBox_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, tasks: Array<{ __typename: 'TaskDocument', id: string, agreement: Types.Agreement, viewerPermissions: Array<Types.PermissionName>, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, isRootItem: boolean, canBeWorkedOn: boolean, deletedAt?: any | null, dueDate?: any | null, isDone: boolean, title: string, docId: string, photoApprovalRequired: boolean, timeTrackingRequired: boolean, rank: number, level: number, parentId?: string | null, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, type: Types.ItemType, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, isVisibleToOtherSide: boolean, workSessionsDuration: number, qaApprovalRequired: boolean, isQaApproved?: boolean | null, approvalRequired: boolean, isApproved?: boolean | null, doneDate?: any | null, priority: number, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> }> };

export const ProjectOverviewNextTasksBox_ProjectFragmentDoc = gql`
    fragment ProjectOverviewNextTasksBox_Project on Project {
  id
  viewerPermissions
  tasks {
    id
    agreement
    viewerPermissions
    items {
      id
      originVersionNumber
      isRootItem
      canBeWorkedOn
      deletedAt
      dueDate
      isDone
      assignee {
        id
      }
      ...TaskTreeItem_TreeItem
      ...TaskTreeItem_TreeListItem
      ...PhotoApprovalProcess
      ...AddTaskWorkSessionsProcess_Item
      ...VirtualItem__DocumentItem
    }
  }
}
    ${TaskTreeItem_TreeItemFragmentDoc}
${TaskTreeItem_TreeListItemFragmentDoc}
${PhotoApprovalProcessFragmentDoc}
${AddTaskWorkSessionsProcess_ItemFragmentDoc}
${VirtualItem__DocumentItemFragmentDoc}`;
export const ProjectOverviewNextTasksBoxDocument = gql`
    query ProjectOverviewNextTasksBox {
  organisationDefaults {
    ... on OrganisationDefaults {
      id
      defaultTaskPhotoIsRequired
    }
  }
}
    `;

/**
 * __useProjectOverviewNextTasksBoxQuery__
 *
 * To run a query within a React component, call `useProjectOverviewNextTasksBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOverviewNextTasksBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOverviewNextTasksBoxQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectOverviewNextTasksBoxQuery(baseOptions?: Apollo.QueryHookOptions<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>(ProjectOverviewNextTasksBoxDocument, options);
      }
export function useProjectOverviewNextTasksBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>(ProjectOverviewNextTasksBoxDocument, options);
        }
export function useProjectOverviewNextTasksBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>(ProjectOverviewNextTasksBoxDocument, options);
        }
export type ProjectOverviewNextTasksBoxQueryHookResult = ReturnType<typeof useProjectOverviewNextTasksBoxQuery>;
export type ProjectOverviewNextTasksBoxLazyQueryHookResult = ReturnType<typeof useProjectOverviewNextTasksBoxLazyQuery>;
export type ProjectOverviewNextTasksBoxSuspenseQueryHookResult = ReturnType<typeof useProjectOverviewNextTasksBoxSuspenseQuery>;
export type ProjectOverviewNextTasksBoxQueryResult = Apollo.QueryResult<ProjectOverviewNextTasksBoxQuery, ProjectOverviewNextTasksBoxQueryVariables>;